import service from '../allservices.jsx'


export function secretQues(actionCallback) {
    fetch(service.secret_ques, {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then(response => {
            if (response.status === 200 || response.status === 201) {
                response.json().then(json => actionCallback(json, "success"))
            } else {
                response.json().then(json => actionCallback(json, "Error"))

            }
        })
}


// WEBPACK FOOTER //
// ./src/services/components/secret_ques.jsx